var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticStyle:{"height":"80vh"},attrs:{"justify":"center","align":"center"}},[_c('p',{staticClass:"display-3 secondary--text"},[_vm._v("YOUR ARE NOT AUTHORIZED TO SEE THIS PAGE")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }